// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-profile-image-button {
  position: absolute;
  top: 5px;
  right: 25px;
  background-color: transparent;
  border: none;
  border-radius: 55%;
  cursor: pointer;
  align-items: center;
  background-color: red;
}

/* Style for the cross icon */
.delete-profile-image-button img {
  width: 20px;
  height: 20px;
}
.profile-main {
  width: 100%;
}

.profile-main .header-part {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 30px 50px;
  background: #fff;
  box-shadow: 0px 1px 15px #0000000f;
}

.profile-main .header-part .left-part {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
}

.header-part .left-part .back {
  border: 1px solid #e3e3e3;
  border-radius: 14px;
  background-color: transparent;
  width: 60px;
  height: 60px;
}

.header-part .left-part .back img {
  transform: rotate(-180deg);
}

.header-part .left-part h2 {
  font-size: 30px;
  font-weight: 300;
  line-height: 42px;
  margin: 0;
}

.header-part .right-part {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.header-part .right-part .nav-link {
  border-radius: 26px;
  background-color: #fdf5f2;
  font-size: 14px;
  font-weight: 500;
  color: #23bee3;
  min-width: 90px;
  font-weight: 400;
  margin: 0 10px;
}

.header-part .right-part .nav-link.active {
  border: 0;
  background-color: #23bee3;
  color: #fff;
}

.form-data .filed #profile-img {
  display: none;
}

.form-data .filed #clinic-img {
  display: none;
}

.form-data .filed label.upload {
  width: 150px;
}

.form-data .filed .profile-pic {
  position: relative;
  display: inline-block;
  gap: 20px;
  width: 150px;
  height: 135px;
}
.profile-pic img {
  height: 100px;
  width: 100px;
  border-radius: 50%;
}
.form-data .filed .profile-pic>p {
  margin: 0;
}

.form-data .filed .file-area input {
  outline: none;
}

.field-error {
  border: 2px solid red !important;
  outline: none !important;
  box-shadow: 0 0 0.25rem rgba(13, 110, 253, .25)
}

.field-error:focus  , .field-error > .form-control:focus{
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.667) !important;
  /* Add a box shadow for more emphasis */

}

.css-t3ipsp-control:hover {
  border-color: #23bde300 !important;
}

.css-t3ipsp-control {
  border-color: #23bde300 !important;
  box-shadow: none !important;
}

.css-13cymwt-control {

  border-color: #23bde300 !important;
  box-shadow: none !important;
}

/* .react-tel-input>.form-control {
  border-color: #23bde300 !important;
  box-shadow: none !important;
} */

.theme-buttonOuteline{
  background-color: white;
  font-size: 14px;
  border-radius: 28px;
  min-width: 300px;
  padding: 14px;
  font-weight: 600;
  color:#ff6036;
  border: 1px solid #ff6036;
}
.theme-buttonOuteline :hover{
  background-color: white;
  font-size: 14px;
  border-radius: 28px;
  min-width: 300px;
  padding: 14px;
  font-weight: 600;
  color:#ff6036;
  border: 1px solid #ff6036;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/profile.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB;AACF;;AAEA;EACE,qDAAqD;EACrD,uCAAuC;;AAEzC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;EAEE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;;GAGG;;AAEH;EACE,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":[".delete-profile-image-button {\n  position: absolute;\n  top: 5px;\n  right: 25px;\n  background-color: transparent;\n  border: none;\n  border-radius: 55%;\n  cursor: pointer;\n  align-items: center;\n  background-color: red;\n}\n\n/* Style for the cross icon */\n.delete-profile-image-button img {\n  width: 20px;\n  height: 20px;\n}\n.profile-main {\n  width: 100%;\n}\n\n.profile-main .header-part {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  padding: 30px 50px;\n  background: #fff;\n  box-shadow: 0px 1px 15px #0000000f;\n}\n\n.profile-main .header-part .left-part {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 20px;\n}\n\n.header-part .left-part .back {\n  border: 1px solid #e3e3e3;\n  border-radius: 14px;\n  background-color: transparent;\n  width: 60px;\n  height: 60px;\n}\n\n.header-part .left-part .back img {\n  transform: rotate(-180deg);\n}\n\n.header-part .left-part h2 {\n  font-size: 30px;\n  font-weight: 300;\n  line-height: 42px;\n  margin: 0;\n}\n\n.header-part .right-part {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.header-part .right-part .nav-link {\n  border-radius: 26px;\n  background-color: #fdf5f2;\n  font-size: 14px;\n  font-weight: 500;\n  color: #23bee3;\n  min-width: 90px;\n  font-weight: 400;\n  margin: 0 10px;\n}\n\n.header-part .right-part .nav-link.active {\n  border: 0;\n  background-color: #23bee3;\n  color: #fff;\n}\n\n.form-data .filed #profile-img {\n  display: none;\n}\n\n.form-data .filed #clinic-img {\n  display: none;\n}\n\n.form-data .filed label.upload {\n  width: 150px;\n}\n\n.form-data .filed .profile-pic {\n  position: relative;\n  display: inline-block;\n  gap: 20px;\n  width: 150px;\n  height: 135px;\n}\n.profile-pic img {\n  height: 100px;\n  width: 100px;\n  border-radius: 50%;\n}\n.form-data .filed .profile-pic>p {\n  margin: 0;\n}\n\n.form-data .filed .file-area input {\n  outline: none;\n}\n\n.field-error {\n  border: 2px solid red !important;\n  outline: none !important;\n  box-shadow: 0 0 0.25rem rgba(13, 110, 253, .25)\n}\n\n.field-error:focus  , .field-error > .form-control:focus{\n  box-shadow: 0 0 5px rgba(255, 0, 0, 0.667) !important;\n  /* Add a box shadow for more emphasis */\n\n}\n\n.css-t3ipsp-control:hover {\n  border-color: #23bde300 !important;\n}\n\n.css-t3ipsp-control {\n  border-color: #23bde300 !important;\n  box-shadow: none !important;\n}\n\n.css-13cymwt-control {\n\n  border-color: #23bde300 !important;\n  box-shadow: none !important;\n}\n\n/* .react-tel-input>.form-control {\n  border-color: #23bde300 !important;\n  box-shadow: none !important;\n} */\n\n.theme-buttonOuteline{\n  background-color: white;\n  font-size: 14px;\n  border-radius: 28px;\n  min-width: 300px;\n  padding: 14px;\n  font-weight: 600;\n  color:#ff6036;\n  border: 1px solid #ff6036;\n}\n.theme-buttonOuteline :hover{\n  background-color: white;\n  font-size: 14px;\n  border-radius: 28px;\n  min-width: 300px;\n  padding: 14px;\n  font-weight: 600;\n  color:#ff6036;\n  border: 1px solid #ff6036;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
